const TickIcon = () => {
	return (
		<svg
			width="18"
			height="18"
			viewBox="0 0 18 18"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M17.457 9C17.457 13.4183 13.8753 17 9.45703 17C5.03875 17 1.45703 13.4183 1.45703 9C1.45703 4.58172 5.03875 1 9.45703 1C13.8753 1 17.457 4.58172 17.457 9Z"
				fill="white"
			/>
			<path
				d="M13.457 6.6L10.7617 9.61054C9.69363 10.8035 9.15959 11.4 8.45703 11.4C7.75447 11.4 7.22044 10.8035 6.15237 9.61054L5.45703 8.83389M17.457 9C17.457 13.4183 13.8753 17 9.45703 17C5.03875 17 1.45703 13.4183 1.45703 9C1.45703 4.58172 5.03875 1 9.45703 1C13.8753 1 17.457 4.58172 17.457 9Z"
				stroke="#494C83"
				strokeLinecap="round"
			/>
		</svg>
	);
};

export default TickIcon;
